import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Modal } from 'react-bootstrap';
import I18n from 'i18n-react';
import TooltipComponent from '../../common/tooltipComponent/TooltipComponent';

import './PassengerList.css';

const propTypes = {
  id: PropTypes.string.isRequired,
  passengers: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      lastName: PropTypes.string,
      ticketNumber: PropTypes.string
    })
  ).isRequired,
  isCallcenterEnabled: PropTypes.bool
};

class PassengerList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false
    };
  }

  showModal = () => {
    this.setState({
      showModal: true
    });
  };

  closeModal = () => {
    this.setState({
      showModal: false
    });
  };

  renderPassenger(passenger, index) {
    return (
      <Row
        id={`passengerList-passenger${index}`}
        key={`passenger-${index}`}
        className="PassengerList__passenger">
        <Col xs={12} md={3} className="PassengerList__box">
          <div className="PassengerList__name verticalAlign">
            <div>
              <b>{`${passenger.name} ${passenger.lastName}`}</b>
            </div>
          </div>
        </Col>
        {this.renderTicket(passenger)}
        <Col xs={12} className="PassengerList__separator">
          <div />
        </Col>
      </Row>
    );
  }

  renderHeader() {
    return (
      <Row className="PassengerList__header">
        <Col xs={12} md={3} className="PassengerList__header-content">
          {I18n.translate('components.passengerList.passenger')}
        </Col>
      </Row>
    );
  }

  renderTicketNumber(passenger, isMobile) {
    if (passenger.ticketNumber) {
      const ticketNumber = <b>{passenger.ticketNumber}</b>;
      if (!isMobile) {
        return ticketNumber;
      } else {
        return I18n.translate('components.passengerList.ticketNumber', {
          number: ticketNumber
        });
      }
    } else {
      if (!isMobile) {
        return (
          <TooltipComponent content={this.renderTicketNumberNotFoundMessage()}>
            <span className="PassengerList__ticketNumber--not-found">
              {I18n.translate('components.passengerList.ticketNumberNotAvailable.handler')}
            </span>
          </TooltipComponent>
        );
      } else {
        return (
          <span onClick={this.showModal} className="PassengerList__ticketNumber--not-found">
            {I18n.translate('components.passengerList.ticketNumberNotAvailable.handler')}
          </span>
        );
      }
    }
  }

  renderTicketNumberNotFoundMessage() {
    return (
      <span>
        {I18n.translate('components.passengerList.ticketNumberNotAvailable.message')}
        <br />
        <strong>
          {I18n.translate('components.passengerList.ticketNumberNotAvailable.phoneNumber')}
        </strong>
      </span>
    );
  }

  renderTicketNumberNotFoundModal() {
    return (
      <Modal
        id={`mdl${this.props.id}`}
        className="PassengerList__modal"
        show={this.state.showModal}
        onHide={this.closeModal}
        bsSize="lg">
        <Modal.Header closeButton={true} />
        <Modal.Body>{this.renderTicketNumberNotFoundMessage()}</Modal.Body>
      </Modal>
    );
  }

  assemblePassengers(passengersList) {
    let passengers = [];

    passengersList.forEach(element => {
      passengers.push(element);
      if (element.infant) {
        passengers.push(element.infant);
      }
    });

    return passengers;
  }

  renderTicket(passenger) {
    if (this.props.isCallcenterEnabled) {
      return (
        <Row>
          <Col xs={12} smHidden mdHidden lgHidden className="PassengerList__ticketNumber mobile">
            {this.renderTicketNumber(passenger, true)}
          </Col>
          <Col xsHidden md={3} className="PassengerList__box">
            <div className="PassengerList__ticketNumber verticalAlign">
              {this.renderTicketNumber(passenger, false)}
            </div>
          </Col>
        </Row>
      );
    }
  }

  render() {
    return (
      <div id={`PassengerList-${this.props.id}`} className="PassengerList">
        {this.renderHeader()}
        {this.assemblePassengers(this.props.passengers).map((passenger, index) =>
          this.renderPassenger(passenger, index)
        )}
        {this.renderTicketNumberNotFoundModal()}
      </div>
    );
  }
}

PassengerList.propTypes = propTypes;

export default PassengerList;



// WEBPACK FOOTER //
// ./src/components/bookingResume/passengerList/PassengerList.jsx